<template>
  <div>

    <div class="card softblue">
      <div class="card-body">
        <div class="media">
          <img :src="userInfo.picture_path ? userInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
          <div class="media-body">
            <span class="badge rose">학생</span>
            <h5>{{userInfo.name}}</h5>
            <span>{{userInfo.school_name}} · {{userInfo.id}}</span>
          </div>
        </div>
      </div>
    </div>

    <h3 class="title">온라인 공개 시험 <span class="number strong mint">{{tableData.length}}</span></h3>

    <template v-if="tableData.length > 0">
      <div class="box-card card-exam" v-for="(exam, index) in tableData" :key="index">
        <div class="d-flex">
          <div class="p-2">
            <img src="/static/img/test.png" />
          </div>
          <div class="p-2 user_exam_title">
            <h2>{{`${exam.class_name} / ${exam.title}`}}</h2>
          </div>
          <div class="p-2 ml-auto" style="padding-top:18px !important">
            <button type="primary" class="btn ellipse mint" v-if="exam.attend_yn === 'N'" @click="goExam(exam.exam_seq, exam.class_seq, exam.class_user_seq, 'Y')">응시</button>
            <button type="primary" class="btn ellipse gray" v-if="exam.attend_yn === 'Y'" @click="goExam(exam.exam_seq, exam.class_seq, exam.class_user_seq, 'N')">응시취소</button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="box-card card-exam-disable text-center">
        현재 등록된 시험이 없습니다.
      </div>
    </template>
  </div>

</template>

<script>

import common from '@/modules/common'

export default {
  name: 'S010401',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      userInfo: {
        picture_path: '',
        name: '',
        id: '',
        school_name: ''
      }
    }
  },
  created () {
    this.loadUserInfo()
    this.retreiveExam()
  },
  methods: {
    loadUserInfo () {
      common.axios.get('/user/load/' + this.$store.getters.user_seq)
        .then(response => {
          const result = response.data
          Object.keys(this.userInfo).forEach(key => {
            this.userInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
        })
    },
    retreiveExam () {
      common.axios.post('/exam/list/online/user', {})
        .then(response => {
          this.tableData = response.data
        })
    },
    goExam (examSeq, classSeq, classUserSeq, attend) {
      const param = {
        exam_seq: examSeq,
        class_seq: classSeq,
        class_user_seq: classUserSeq,
        attend_yn: attend
      }
      common.axios.post('/exam/attend/online/user', param)
        .then(response => {
          // console.log(response.data)
          if (response.data.status === 1) {
            if (attend === 'Y') {
              // 현재 시험이 공개된 상태
              if (response.data.seq === 11001) {
                this.$confirm('바로 해당 시험 답안지 작성을 하시겠습니까?', '', {
                }).then(() => {
                  const param = {
                    exam_seq: examSeq,
                    class_seq: classSeq
                  }
                  this.$router.push({name: 'S010102', params: param})
                }).catch(() => {
                  this.$message('해당 시험에 응시 되었습니다.')
                })
              } else {
                this.$message('해당 시험에 응시 되었습니다.')
              }
            } else {
              this.$message('해당 시험이 응시 취소 되었습니다.')
            }
          } else {
            this.$message.warning(response.data.message)
          }
          this.retreiveExam()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/S010401.vue